import { Card } from '../../model/Card';
import { GameStage } from '../../model/enumeration/GameStage.enum';
import gameStore from '../../store/GameStore';
import playerStore from '../../store/PlayerStore';
import { WEvent } from './WEvent';

export class WTableEvent extends WEvent {
  gameId: string;
  stage: GameStage;
  boardNumber: number;
  cards: Card[];

  constructor(event: WTableEvent) {
    super(event.tableId, event.eventType, event.eventTime);
    Object.assign(this, event);
  }

  applyWebsocketChanges = (): Promise<void> =>
    gameStore.findActiveGame(this.tableId).then(game => {
      if (this.boardNumber === 1) {
        game.setStage(this.stage);
        if (this.stage !== GameStage.PREFLOP) {
          playerStore.modifyAllPlayersWithSingleAction(
            game.players,
            player => (player.totalBet = 0),
          );
        }
      }
      if (this.boardNumber === 1) {
        game.setBoard(this.cards);
      }
      if (this.boardNumber === 2) {
        game.setBoard2(this.cards);
      }
      if (this.boardNumber === 3) {
        game.setBoard3(this.cards);
      }
      game.resetActivePlayer();
    });
}
